import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { IdNamePair } from '../../types/global';
export interface ReactConfig {
  applicationInsightsConnectionString: string;
}

export const frameworkAgreementsApi = createApi({
  reducerPath: 'frameworkAgreementsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/frameworkAgreements/frameworkAgreements`,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  tagTypes: ['FrameworkAgreements'],
  endpoints: (builder) => ({
    getAllFrameworkAgreements: builder.query<IdNamePair[], void>({
      query: () => ({
        url: ``,
      }),
      providesTags: ['FrameworkAgreements'],
    }),
  }),
});

export const { useLazyGetAllFrameworkAgreementsQuery } = frameworkAgreementsApi;
